import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedLanguage:'TH',
    selectedFlights:{},
    passengerFfaresOfSelectedFlights:{},
    bookingSid:{},
    searchBoxValues:{
      origin:"",
      destination:"",
      dateOfDeparture:null,
      dateOfReturn:null,
      trip:false,
      seatClass:"",
      airline:"--",
      passengerCountByPax:{
        adult:0,
        child:0,
        infant:0,
        student:0
      }
    },
    wholesaleId:0,
    urlId:0,
    searchCriteriaBase64:"",
    searchCriteriaBase64M:"",
    mlv:1,
    totSectors:1,
    selectedFlightsNew:[],
    originM:[],
    destinationM:[],
    triptype:null,
    sellingCurrency: {
      code:'',
      fxRate:1
    }
  },
  mutations: {
    updateSellingCurrency(state, value) {
      state.sellingCurrency = value;
    },
    initializeAppIdleness(state,isIdle){
      state.idleVue.isIdle = isIdle;
    },
    selectLanguage(state,lang){
      state.selectedLanguage = lang;
    },
    updateFlightSelection(state,flightFare){
      state.selectedFlights =flightFare;
    },
    updatePassengerFaresOfSelectedFlights(state,psFr){
      state.passengerFfaresOfSelectedFlights = psFr;
    },
    updateSidForShowingBookingInfo(state,sid){
      state.bookingSid = sid;
    },
    updateSearchBoxValues(state,values){
      state.searchBoxValues.origin = values.origin;
      state.searchBoxValues.destination = values.destination;
      state.searchBoxValues.dateOfDeparture = values.departureDate;
      state.searchBoxValues.dateOfReturn = values.returnDate;
      state.searchBoxValues.airline = values.airline;
      state.searchBoxValues.passengerCountByPax.adult = values.adtPassengerCount;
      state.searchBoxValues.passengerCountByPax.child = values.cnnPassengerCount;
      state.searchBoxValues.passengerCountByPax.infant = values.infPassengerCount;
      state.searchBoxValues.passengerCountByPax.student = values.stuPassengerCount;
      state.searchBoxValues.trip = values.trip;
      state.searchBoxValues.seatClass = values.seatClass;
      state.searchBoxValues.markupLevel = values.markupLevel;
    },
    updateWholesaleIdAndUrlId(state,values){
      state.wholesaleId = values[0];
      state.urlId = values[1];
      state.mlv = values[2];
    },
    updateSearchCriteriaBase64(state,value){
      state.searchCriteriaBase64 = value;
    },
    updateSearchCriteriaBase64M(state,value){
      state.searchCriteriaBase64M = value;
    },
    updateMarkupLevel(state, mlv){
      state.mlv = mlv;
    },
    updateTotalSectors(state, tsec){
      state.totSectors = tsec;
    },
    updateFlightSelectionNew(state, flightFareNew){
      state.selectedFlightsNew = flightFareNew;
    },
    updateOriginM(state, ori){
      state.originM = ori;
    },
    updateDestinationM(state, dest){
      state.destinationM = dest;
    },
    updatetrip(state, trip){
      state.triptype = trip;
    },
  },
  actions: {

  }
})
